"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPrice = formatPrice;

function formatPrice(value) {
  if (!value) {
    return null;
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}